import { useCallback, useContext, useState } from "react";
import { franchiseTiles } from "../../../../constant";
import { NavigatorContext } from "../../../../context";

export const useFranchiseCTA = () => {
  const { navigateTo } = useContext(NavigatorContext);
  const [activeFranchise, setactiveFranchise] = useState(franchiseTiles[0]);

  const navigateToStoreLocator = useCallback(() => {
    navigateTo({ route: "/store-locator" });
  }, [navigateTo]);

  return {
    franchiseTiles,
    activeFranchise,
    setactiveFranchise,
    navigateToStoreLocator,
  };
};
